import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "field p-3 pb-0 border-1 border-gray-100 border-round-md"
}
const _hoisted_2 = { class: "flex overflow-hidden" }
const _hoisted_3 = { class: "flex-none flex" }
const _hoisted_4 = { class: "pb-3" }
const _hoisted_5 = { class: "flex-none flex" }

import { ref, computed, onMounted, toRefs, watch } from 'vue';
import { useRouting } from '@/composables';
import { useTenantIntegrationStore, useTenantIntegrationSISSchoolDayStore } from '@/store';
import SchoolDaySISOrganizationsActions from './SchoolDaySISOrganizationsActions.vue';
import SchoolDaySISOrganizationModal from './SchoolDaySISOrganizationModal.vue';

interface PropsInterface {
  integration?: null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SchoolDaySISOrganizations',
  props: {
    integration: { default: null }
  },
  setup(__props: any) {

const props = __props;

const tenantIntegrationStore = useTenantIntegrationStore();

const tenantIntegrationSISSchoolDayStore = useTenantIntegrationSISSchoolDayStore();

const { integration } = toRefs(props);

const $routing = useRouting();

const organizations = ref([]);

const connection = ref(null);

const tenantId = ref(Number($routing.route.params.id));

watch(tenantIntegrationStore.integrations, () => init());

onMounted(() => init());

const init = () => defineIntegration();

const defineIntegration = () => {
  if (integration.value) organizations.value = integration.value.integration_organizations;
};

const totalOrganizations = computed(() => (organizations.value.length ? organizations.value.length : '0'));

const onConnectOrganizationsCreate = () => {
  tenantIntegrationStore.modalAction = 'create';
  tenantIntegrationStore.openModal = true;
};

const onConnectOrganizationsUpdate = (id: number) => {
  connection.value = integration.value.integration_organizations.find((item) => item.id === id);
  tenantIntegrationStore.modalAction = 'update';
  tenantIntegrationStore.openModal = true;
};

const onConnectOrganizationsCancel = () => {
  tenantIntegrationStore.openModal = false;
  connection.value = null;
};

const onConnectOrganizationDataSync = async (id: number) => tenantIntegrationSISSchoolDayStore.sync(tenantId.value, id);

return (_ctx: any,_cache: any) => {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_unref(integration))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("span", null, "Organizations", -1)),
              _createVNode(_component_Tag, {
                value: totalOrganizations.value,
                rounded: "",
                class: "ml-2 p-2 border-circle w-1rem h-1rem text-xs text-white"
              }, null, 8, ["value"])
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-grow-1 flex" }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_AppButton, {
              type: "text",
              size: "small",
              text: "Add Organization Connection",
              "icon-left": "add",
              onClick: onConnectOrganizationsCreate
            })
          ])
        ]),
        (_unref(tenantIntegrationStore).openModal)
          ? (_openBlock(), _createBlock(SchoolDaySISOrganizationModal, {
              key: 0,
              connection: connection.value,
              integration: _unref(integration),
              "tenant-id": tenantId.value,
              onCancel: onConnectOrganizationsCancel
            }, null, 8, ["connection", "integration", "tenant-id"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataTable, {
          value: organizations.value,
          "data-key": "id",
          scrollable: "",
          "scroll-height": "400px"
        }, {
          empty: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("There are no organizations connected", -1)
          ]))]),
          default: _withCtx(() => [
            (organizations.value.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Column, {
                    header: "Organization",
                    field: "name",
                    "header-style": "width: 5em"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createVNode(_component_RouterLink, {
                        to: `/organizations/${data.organization_id}`,
                        class: "font-semibold",
                        target: "_blank",
                        textContent: _toDisplayString(data.organization_name)
                      }, null, 8, ["to", "textContent"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "SIS Organization",
                    field: "organization_sis_name"
                  }),
                  _createVNode(_component_Column, {
                    field: "actions",
                    header: "Actions",
                    "body-style": "justify-content: center; font-size: .8725rem; max-width: 10rem;",
                    "header-class": "justify-content-center mw-10rem"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createVNode(SchoolDaySISOrganizationsActions, {
                        data: data,
                        integration: _unref(integration),
                        "tenant-id": tenantId.value,
                        onSync: ($event: any) => (onConnectOrganizationDataSync(data.id)),
                        onUpdate: onConnectOrganizationsUpdate
                      }, null, 8, ["data", "integration", "tenant-id", "onSync"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value"])
      ]))
    : _createCommentVNode("", true)
}
}

})